import { TimeOption } from '../models/entities/timeslot.model';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useTimePicker = (props, { emit }) => {
  // ----------------------------------------
  // methods

  const changeTime = (event: Event): void => {
    const time = props.availableTime.find(
      (el: HTMLInputElement) =>
        el.value === (event.target as HTMLInputElement).value
    );
    emit('changeTime', time);
  };

  const isSelected = (optionTime: TimeOption): boolean => {
    return props.selectedTime && props.selectedTime.value === optionTime.value;
  };

  return { changeTime, isSelected };
};

export default useTimePicker;
